export const MSG_DISALLOWED = ['img', 'image', 'iframe', 'video', 'audio', 'source', 'picture', 'embed', 'object'];
